import React from "react";

const Pagination = ({
  paginationInfo,
  handleNextPage,
  handlePreviousPage,
  onPageChange,
  onPageSizeChange,
}) => {
  const { pageNumber, pageSize, totalPages, totalElements } = paginationInfo;

  const pageSizes = [10, 25, 50, 75, 100];
  const startIndex = pageNumber * pageSize + 1;
  const endIndex = Math.min(startIndex + pageSize - 1, totalElements);

  const BRAND_BLUE = "#0147C8";

  // Helper to generate the condensed pagination style
  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      // Show all pages if there are 5 or fewer
      for (let i = 0; i < totalPages; i++) pages.push(i);
    } else {
      if (pageNumber <= 2) {
        // Near the start: show 1, 2, 3, ... last page
        pages.push(0, 1, 2, "...", totalPages - 1);
      } else if (pageNumber >= totalPages - 3) {
        // Near the end: show 1, ..., last-3, last-2, last-1
        pages.push(0, "...", totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        // In the middle: show 1, ..., current-1, current, current+1, ..., last page
        pages.push(0, "...", pageNumber - 1, pageNumber, pageNumber + 1, "...", totalPages - 1);
      }
    }
    return pages;
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      {/* Showing text */}
      <div className="mb-2">
        <span>
          Showing {startIndex} to {endIndex} of {totalElements} entries
        </span>
      </div>

      {/* Pagination Controls and Filter */}
      <div className="d-flex align-items-center mb-2">
         {/* Page Size Filter */}

         <div className="mb-2">
        <span>Rows per page: </span>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;

         <div className="mb-2">
          <select
            className="form-select form-select-sm"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>&nbsp;&nbsp;&nbsp;&nbsp;

        {/* Pagination Controls */}
        <ul className="pagination pagination-sm mb-2">
          {/* Previous Button */}
          <li className={`page-item ${pageNumber === 0 ? "disabled" : ""}`}>
            <button
              className="page-link"
              aria-label="Previous"
              onClick={handlePreviousPage}
            >
              &lt;
            </button>
          </li>

          {/* Page Numbers */}
          {generatePageNumbers().map((page, index) => (
            <li
              key={index}
              className={`page-item ${
                page === "..." ? "disabled" : page === pageNumber ? "active" : ""
              }`}
            >
              <button
                style={{ backgroundColor: BRAND_BLUE, borderColor: BRAND_BLUE }}
                className="page-link rounded-circle"
                onClick={() => typeof page === "number" && onPageChange(page, pageSize)}
                disabled={page === "..."}
              >
                {page === "..." ? "..." : page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li
            className={`page-item ${
              pageNumber >= totalPages - 1 ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              aria-label="Next"
              onClick={handleNextPage}
            >
              &gt;
            </button>
          </li>
        </ul>

    
      </div>
    </div>
  );
};

export default Pagination;
